import React, {useState, useEffect} from 'react';
import { useNavigate, Link} from 'react-router-dom';
import '../styles/global.css'; // Seu CSS global
import axios from 'axios';
import { CircularProgress } from '@mui/material';
import { AccessAlarm, ThreeDRotation } from '@mui/icons-material';
import MenuAssociados from '../components/MenuAssociados';

function ModeloEmail() {
    const [searchTerm, setSearchTerm] = useState('');
    const [modelosEmail, setModelosEmail] = useState([]);
    const [isLoadingMOD, setIsLoadingMOD] = useState(false);
    const [menuAberto, setMenuAberto] = useState(false);
    const associado = parseInt(sessionStorage.getItem('pesAssociado'));
    const navigate = useNavigate();

    const now = new Date();
    const customFormatDate = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false
    }).format(now).replace(/\//g, '/').replace(',',''); // Replace slashes with hyphens
    
    const customFormatSmallDate = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit'
    }).format(now).replace(/\//g, '/').replace(',',''); // Replace slashes with hyphens

    function handleNovoModelo(){
        const modeloEmail = {
            IdModeloEmail: 0,
            emlDescricao: '',
            emlAssunto: '',
            emlCorpo: '',
            emlStatus: 1,
            emlObservacoes: '',
            emlCriadoPor: sessionStorage.nomeUsuario,
            emlCriadoEm: customFormatDate,
            emlAlteradoPor: sessionStorage.nomeUsuario,
            emlAlteradoEm: customFormatDate,
            emlCodigoGUID: crypto.randomUUID()
            }
            navigate('/ModeloEmail', { state: { modeloInfo:modeloEmail } });
        }

    function handleEditModelo(modelo) {
        const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
        axios
        .post(process.env.REACT_APP_API_URL + '/routes.php?metodo=obtemModeloEmail', 
            { 
                IdModeloEmail: modelo? modelo.IdModeloEmail : 0 
            }, {
            headers: {
                'X-Access-Token': tokenAPI,
                'Content-Type': 'application/json; charset=UTF-8'
            }
        })
        .then(response => {
            if (response.data && response.data.IdModeloEmail) {
                modelo.emlCorpo = response.data.emlCorpo;
                if(modelo.emlCorpo === '')
                    modelo.emlCorpo = response.data.emlCorpo;
                 // Atualiza o estado com o corpo do email obtido
            } else {
                console.error('Modelo de email não encontrado ou resposta inválida:', response.data);
                setErrorMessage('Ocorreu um erro ao carregar o modelo de email. Por favor, tente novamente.');
            }
        })
        .catch(error => {
            console.error('Erro ao obter modelo de email:', error);
            setErrorMessage('Ocorreu um erro ao carregar o modelo de email. Por favor, tente novamente.');
        });
        //console.log(modelo); return;
        if(modelo.emlCorpo !== '')
        navigate('/ModeloEmail', { state: { modeloInfo: modelo } });
    }

    useEffect(() => {
        setIsLoadingMOD(true);
        var token = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
        
        axios
        .get(process.env.REACT_APP_API_URL + '/routes.php?metodo=obtemModelosEmail',
            {
                headers: {
                "X-Access-Token": token,
                "Content-Type": "application/json; charset=UTF-8"
                }
            }
        )
        .then(response => {
            //console.log(response.data); return;
            setModelosEmail(response.data);
            setIsLoadingMOD(false);
        })
        .catch(error => {
            console.error('Erro ao obter modelos de email:', error);
            setIsLoadingMOD(false);
        });
    }, []); 

    //console.log(modelosEmail);


  //salvar log de navegação
  useEffect(() => {
    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const log = {
      IdPessoa: sessionStorage.IdPessoa ? sessionStorage.IdPessoa : 0,
      logTipo: "Navegação",
      logModulo: "Página de Modelos de Email",
      logCriadoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : "Visitante",
      logCriadoEm: new Date().toISOString(),
      logCodigoGUID: crypto.randomUUID()
    };
    axios                    
      .post(process.env.REACT_APP_API_URL 
          + '/routes.php?metodo=novoLog', 
          log, {
              headers: {
                  "X-Access-Token" : tokenAPI,
                  "Content-Type": "application/json; charset=UTF-8"
              }
          }
      )
      .then(response => {
          //console.log(response.data[0].mensagem);
      })
      .catch(error => {
          console.error('Erro ao enviar log:', error);
      });
  }, []);


    return (
        <>
            <main>
                <div>
                    <MenuAssociados />
                </div>
                <div className='headerMain'>
                    <label className='labelTitulo' >MODELOS DE EMAIL</label>
                    <label className='labelSubTitulo'>Cadastro e gerenciamento</label>
                </div>
                <div className="containerBarraPesquisa">
                    {parseInt(sessionStorage.pesAdmin) === 1 ? (
                        <button className="buttonModalPadrao" onClick={handleNovoModelo}>
                            NOVO MODELO
                        </button> ) : ('')}

                    <input className='inputBarraPesquisa'
                    placeholder='PESQUISAR'
                    type='text'
                    id='inputPesquisa'
                    name='inputPesquisa'
                    onChange={event => {
                        setSearchTerm(event.target.value);
                    }}
                    />
                </div>
                <div className="tabelaPadrao">
                    <table>
                        <thead>
                            <tr>
                                <th className="tdAlignLeft">Modelo</th>
                                <th className="tdAlignLeft">Observações</th>
                                <th className="tdAlignCenter w10">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* Aqui você pode mapear os modelos de email e exibi-los */}
                            {
                                isLoadingMOD ? 
                                <tr>
                                    <td colSpan="2" style={{ textAlign: 'center' }}>
                                        <CircularProgress />
                                    </td>
                                </tr>
                                :
                                modelosEmail.map((modelo) => (
                                    <tr key={modelo.IdModeloEmail} onClick={() => handleEditModelo(modelo)} >
                                        <td className="tdAlignLeft" >{modelo.emlDescricao}</td>
                                        <td className="tdAlignLeft" >{modelo.emlObservacoes}</td>
                                        <td className="tdAlignCenter w10" >{modelo.emlStatus}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                    {modelosEmail.length > 0 && modelosEmail ? (<div></div>) : (<div>sem modelo cadastrado</div>)}
                    
                </div>
            </main>
        </>
    );
}

export default ModeloEmail;